import { createFileRoute } from "@tanstack/react-router";
import { ReleaseNotesPage } from "#/modules/util.release-notes/components/release-notes-page";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/release-notes/",
)({
  component: ReleaseNotesPage,
});
